module.exports = __webpack_public_path__ + "img/image7.629ab4d9.png";